import styled from "styled-components";
import { BundleItemProps } from "./types";

const StyledProduct = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.25em;
  img {
    width: 60px;
  }
`;

const StyledProductText = styled.span`
  font-size: 22px;
  color: ${(props: any) => props.color};
  font-weight: bold;
  text-shadow: 1px 1px 3px #693510, -1px -1px 3px #693510, 1px -1px 3px #693510,
    -1px 1px 3px #693510;
`;

function BundleProduct({ img, color, amount }: BundleItemProps) {
  const transformAmount = (amount: number): string => {
    if (amount > 1000000) {
      return amount / 100000 + "M";
    }
    if (amount > 10000) {
      return amount / 1000 + "K";
    }
    return amount.toString();
  };

  return (
    <StyledProduct>
      <img src={img} alt='bundle product' />
      <StyledProductText color={color}>
        {transformAmount(amount ?? 0)}
      </StyledProductText>
    </StyledProduct>
  );
}

export default BundleProduct;
